<!-- https://xd.adobe.com/view/5a99e1ec-5384-4360-a0f7-d32f2e012228-0fca/specs/ -->
<!-- https://docs.google.com/presentation/d/1d_O6nM_jbVWXj20W_5KjxkR_8fwRXV3JKD3D4bXYOqM/edit#slide=id.g13a94655b6d_0_0 -->
<!-- https://docs.google.com/document/d/1JOy1cSFY-KGBVHjjZMcWkEtaLlliAzMHHh6ceHp8gBo/edit -->
<template>
  <div class="animated fadeIn py3">
    <div class="clearfix gibson px3 mb2">
      <!-- mobile view -->
      <div class="col-12 px0" v-if="showMobile">
        <div class="clearfix  mb1">
          <div class="col-12 px0 mt0">
            <!-- 
            if partner has two or more recommendations in the last 30 days show this.
            insert number of reviews
            -->
          <p class="h5 primarycolor line-height-golden gibson mb2" v-if="recommendtions !== 0">Du har modtaget {{ recommendtions }} anbefalinger inden for den sidste måned - godt gået!</p>
          <div class="col-12 px0 mt1">
            <a href="#/auto-anbefalinger" class="outlined-primary-button p2 gibson not-rounded flex justify-center items-center col-12">
              <p class="h5 gibson line-height-1 mb0 pr1 flex-none semi-bold left-align">
                Sæt anbefalinger på autopilot
              </p>
              <i class="el-icon-right"></i>
            </a>
          </div>
          </div>
          <div class="col-12 px0 mt3 gibson">
            <p class="h3 semi-bold line-height-2 mt4 mb3 darkblue">Læs og besvar dine anbefalinger</p>
            <b-collapse id="filterReviews">
              <form action="">
                <div class="clearfix py1 mt2">
                  <div class="col-12 px0">
                    <p class="h5 darkblue gibson mb2">Antal stjerner</p>
                  </div>
                  <!-- 5 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="5" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 4 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="4" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 3 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="3" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 2 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="2" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 1 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="1" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- unanswered -->
                  <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div>
                      <input type="checkbox" class="shadow" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2 relative" style="top:-3px;">
                      <p class="h5 gibson darkblue mb0">
                        Ubesvarede anbefalinger
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </b-collapse>
            <haandvaerker></haandvaerker>
          </div>
          <div class="col-12 px0">
            <button v-b-toggle.filterReviews class="outlined-standard-button gibson p2 col-12 not-rounded flex justify-center items-center line-height-1 my2">
              <span class="h4 semi-bold pr2">Filter</span>
              <span class="when-closed">
                <span class="relative" style="top:-1px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </span>
              <span class="flex-none when-opened">
                <span class="relative" style="top:-1px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                </span>
              </span>
            </button>
            <collectreviews></collectreviews>
          </div>
        </div>
        <div class="col-12 lightgrey-background py2 mb2">
          <span class="h5 darkblue">NY MULIGHED TIL DIG:</span>
          <p>Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:</p>
          <p>Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’</p>
        </div>
        <reviews :ratingVal="ratingVal" :premonth="items.premonth" :ratingNocomment="ratingNocomment" @UpdateAnb="UpdateAnb"></reviews>
      </div>
      <!-- desktop view -->
      <div class="col-12 px0" v-if="!showMobile && !showXXL">
        <div class="clearfix flex justify-start items-center">
          <div class="col-9 mx1 mt3 gibson pl0 mb3">
            <p class="h5 primarycolor line-height-golden gibson mb0" v-if="recommendtions !== 0">Du har modtaget {{ recommendtions }} anbefalinger inden for den sidste måned - godt gået!</p>
            <div class="flex justify-between items-start">
              <div>
                <p class="h3 semi-bold line-height-2 mt2 mb1 darkblue">Læs og besvar dine anbefalinger</p>
                <a href="#/auto-anbefalinger">
                  <p class="h5 gibson line-height-golden primarycolor">
                    Sæt anbefalinger på autopilot
                  </p>
                </a>
              </div>
              <button v-b-modal.filterReviews class="outlined-standard-button h5 gibson p2 not-rounded flex justify-center items-center">
                <span>Filter</span>
                <span class="mx2">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </button>
            </div>
            <b-modal hide-footer id="filterReviews" ref="filterReviewsModal">
              <template v-slot:modal-title>
                <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                  Filtrer
                </p>
              </template>
              <form action="">
                <div class="clearfix py1 mt2">
                  <div class="col-12 px0">
                    <p class="h5 darkblue gibson regular mb2">Antal stjerner</p>
                  </div>
                  <!-- 5 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="5" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="5" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 4 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="4" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="4" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 3 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="3" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="3" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 2 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="2" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="2" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 1 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="1" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="1" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- unanswered -->
                  <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingNocomment" value="1" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2 relative" style="top:-3px;">
                      <p class="h5 regular gibson darkblue mb0">
                        Ubesvaret anbefalinger
                      </p>
                    </div>
                  </div>
                </div>
              </form>
              <template v-slot:modal-footer>
                <div class="col-12 flex justify-start px0">
                  <button @click="hideModal" class="outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center">
                    <span class="mx1"><i class="el-icon-back"></i></span>
                    <span>Luk</span>
                  </button>
                </div>
              </template>
            </b-modal>
            <haandvaerker></haandvaerker>
          </div>
        </div>
        <div class="col-12 lightgrey-background py2 mb2">
          <span class="h5 darkblue">NY MULIGHED TIL DIG:</span>
          <p>Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:</p>
          <p>Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’</p>
        </div>
        <reviews :ratingVal="ratingVal" :premonth="items.premonth" :ratingNocomment="ratingNocomment" @UpdateAnb="UpdateAnb"></reviews>
      </div>
      <!-- xxl view -->
      <div class="col-12 pl4" v-if="showXXL">
        <div class="clearfix flex justify-start items-center">
          <div class="col-12 mx1 mt3 gibson pl0 mb4">
            <p class="h5 primarycolor line-height-golden gibson mb3" v-if="recommendtions !== 0">Du har modtaget {{ recommendtions }} anbefalinger inden for den sidste måned - godt gået!</p>
            <div class="flex justify-between items-start">
              <div>
                <p class="h3 semi-bold line-height-2 mt2 mb1 darkblue">Læs og besvar dine anbefalinger</p>
                <p class="h5 gibson line-height-golden">
                  <a href="#/auto-anbefalinger" class="primarycolor">
                    Sæt anbefalinger på autopilot
                  </a>
                </p>
              </div>
              <button v-b-modal.filterReviews class="outlined-standard-button h5 gibson p2 not-rounded flex justify-center items-center">
                <span>Filter</span>
                <span class="mx2">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                </span>
              </button>
            </div>
            <b-modal hide-footer centered size="sm" id="filterReviews" ref="filterReviewsModal">
              <template v-slot:modal-title>
                <p class="h5 semi-bold darkblue gibson line-height-1 my2">
                  Filtrer
                </p>
              </template>
              <form action="">
                <div class="clearfix p2 mt2">
                  <div class="col-12 px0">
                    <p class="h6 darkblue semi-bold gibson mb2">Antal stjerner</p>
                  </div>
                  <!-- 5 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="5" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="5" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 4 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="4" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="4" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 3 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="3" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="3" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 2 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="2" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="2" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- 1 -->
                  <div class="col-12 px0 flex justify-start items-center mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingVal" value="1" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2">
                      <image-rating src="/static/svg/single-house.svg" :max-rating="5" :increment="0.5" :item-size="18" :spacing="1" :show-rating="false" :rating="1" :read-only="true"></image-rating>
                    </div>
                  </div>
                  <!-- unanswered -->
                  <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div>
                      <input type="checkbox" class="shadow" v-model="ratingNocomment" value="1" style="width:18px;height:18px;outline:none;">
                    </div>
                    <div class="px2 relative" style="top:-3px;">
                      <p class="h6 semi-bold gibson darkblue mb0">
                        Ubesvaret anbefalinger
                      </p>
                    </div>
                  </div>
                </div>
              </form>
              <template v-slot:modal-footer>
                <div class="col-12 flex justify-center px0">
                  <button @click="hideModal" class="outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center">
                    <span class="mx1"><i class="el-icon-back"></i></span>
                    <span>Luk</span>
                  </button>
                </div>
              </template>
            </b-modal>
            <haandvaerker></haandvaerker>
          </div>
        </div>
        <div class="col-12 lightgrey-background py2 mb2">
          <span class="h5 darkblue">NY MULIGHED TIL DIG:</span>
          <p>Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:</p>
          <p>Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’</p>
        </div>
        <reviews :ratingVal="ratingVal" :premonth="items.premonth" :ratingNocomment="ratingNocomment" @UpdateAnb="UpdateAnb"></reviews>
      </div>
    </div>
  </div>
</template>
<script>
import collectreviews from './CollectReview'
import Haandvaerker from './haandvaerker'
import reviews from './Reviews'
import reviewsdesktop from './ReviewsDesktop'
import {ImageRating} from 'vue-rate-it'
export default {
  name: 'anbefalinger',
  components: {
    Haandvaerker,
    collectreviews,
    reviews,
    reviewsdesktop,
    ImageRating
  },
  data () {
    return {
      myHTML: '',
      recommendtions: 0,
      show: false,
      showMobile: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      items: [],
      ratingVal: [],
      ratingNocomment: false,
      images: []
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width >= 1000) {
      this.showXXL = true
    } else {
      this.showXXL = false
    }
    this.Reload()
  },
  methods: {
    hideModal () {
      this.$refs['filterReviewsModal'].hide()
    },
    UpdateAnb (recommendtions) {
      this.recommendtions = recommendtions
    },
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>
<style>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>


// WEBPACK FOOTER //
// ReadAnbefalinger.vue?066f5654